import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

interface Props {
  className?: string;
}

const AbcIcon = (props: Props) => {
  const { className } = props;

  return (
    <SvgIcon className={className} viewBox="0 0 21 21">
      <defs>
        <path
          d="M 0 0  L 48 0  L 48 48  L 0 48  Z "
          fillRule="evenodd"
          fill="black"
          id="path798"
        />
        <clipPath id="clip799">
          <use xlinkHref="#path798" />
        </clipPath>
        <filter
          x="-50.00%"
          y="-50.00%"
          width="200.00%"
          height="200.00%"
          filterUnits="objectBoundingBox"
          id="filter800"
        >
          <feColorMatrix
            type="matrix"
            values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0  "
            in="SourceGraphic"
          />
        </filter>
      </defs>
      <g transform="matrix(1 0 0 1 -1914 -5708 )">
        <g
          transform="matrix(0.4375 0 0 0.4375 1914 5708 )"
          clipPath="url(#clip799)"
          filter="url(#filter800)"
        >
          <path d="m15.5 45-3-2.25V33.5h-3q-1.2 0-2.1-.9-.9-.9-.9-2.1v-16H6q-.65 0-1.075-.425Q4.5 13.65 4.5 13q0-.65.425-1.075Q5.35 11.5 6 11.5h6.5V7H11q-.65 0-1.075-.425Q9.5 6.15 9.5 5.5q0-.65.425-1.075Q10.35 4 11 4h6q.65 0 1.075.425.425.425.425 1.075 0 .65-.425 1.075Q17.65 7 17 7h-1.5v4.5H22q.65 0 1.075.425.425.425.425 1.075 0 .65-.425 1.075-.425.425-1.075.425h-.5v16q0 1.2-.9 2.1-.9.9-2.1.9h-3Zm-6-14.5h9v-4h-4q-.4 0-.7-.3-.3-.3-.3-.7 0-.4.3-.7.3-.3.7-.3h4v-4h-4q-.4 0-.7-.3-.3-.3-.3-.7 0-.4.3-.7.3-.3.7-.3h4v-4h-9ZM30 44q-1.2 0-2.1-.9-.9-.9-.9-2.1V27.7q0-1.6.4-2.425.4-.825 1.05-1.525.95-1 1.25-1.55.3-.55.3-1.2v-1.5h-.5q-.65 0-1.075-.425Q28 18.65 28 18q0-.65.45-1.075.45-.425 1.05-.425h10q.65 0 1.075.425Q41 17.35 41 18q0 .65-.425 1.075-.425.425-1.075.425H39V21q0 .6.375 1.25T40.7 23.9q.65.7.975 1.45.325.75.325 2.35V41q0 1.2-.9 2.1-.9.9-2.1.9Zm0-15h9v-1.3q0-.9-.5-1.6-.5-.7-1.1-1.45-.75-.95-1.075-1.75Q36 22.1 36 21v-1.5h-3V21q0 1.05-.3 1.85t-1.05 1.75q-.6.75-1.125 1.475Q30 26.8 30 27.7Zm0 6h9v-4h-9Zm0 6h9v-4h-9Zm0-6h9Z" />
        </g>
      </g>
    </SvgIcon>
  );
};

export default AbcIcon;
